exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.apartment-ticket--border-bottom-2[data-v-03b80af8] {\n  border-bottom: 2px solid #f92ac2;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/block/components/block-apartment-tickets/styles.scss"],"names":[],"mappings":";AAEE;EACE,iCAHe;CAIhB","file":"styles.scss","sourcesContent":["$secondary: #f92ac2;\n.apartment-ticket {\n  &--border-bottom-2 {\n    border-bottom: 2px solid $secondary;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03b80af8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/block/components/block-apartment-tickets/styles.scss
// module id = UuHm
// module chunks = 0